import { PerAdultLabel } from '@/src/components/common/srp/perAdultLabel'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { Alert, Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { Plan } from '../types'
type FareModalFooterProps = {
    selectedPlan: Plan
    handleFareFamilyBook: () => void
    exclusiveBenefits?: string | null
    /** CTA label override (e.g. "Book now" on the final tab of the split-view two-leg popup). Defaults to "Continue". */
    actionLabel?: string
    /** Resolved price to show instead of `selectedPlan.displayPrice` — the RT split view's final tab uses
     *  it to show the onward+return SUM (plain fares) or the special combo's round-trip total. */
    displayPriceOverride?: string
    /** Retail round-trip sum struck through next to the price (RT split view, special combo applies). */
    strikeOffPrice?: string
    /** Show the "Round trip total price" label under the price (RT split view's final tab). */
    showRoundTripLabel?: boolean
    /** Advisory note under the price — RT split view uses it for "review all fare benefits in the next step",
     *  since each leg's Regular card carries the special combo's benefits regardless of the other leg's pick. */
    note?: string
    disableCoupon?: boolean
}

function FareModalFooter ({ selectedPlan, handleFareFamilyBook, exclusiveBenefits, actionLabel, displayPriceOverride, strikeOffPrice, showRoundTripLabel, note, disableCoupon = false }: FareModalFooterProps) {
    const hasPrice = !isNaN(selectedPlan.price)
    const t = useTranslations('common')
    const { selectedJourneyLeg } = useSearchResults()

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%" sx={{ p: 1 }}>
            <Box>
                {hasPrice && (
                    <>
                        {showRoundTripLabel && (
                            <Typography sx={{ fontSize: '13px', color: 'text.secondary', }}>
                                {t('roundTripTotalPrice')}
                            </Typography>
                        )}
                        <Box display="flex" alignItems="baseline" gap={1}>
                            {!!strikeOffPrice && (
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'grey.500', textDecoration: 'line-through', fontSize: '16px' }}
                                >
                                    {strikeOffPrice}
                                </Typography>
                            )}
                            <Typography variant="h5" fontWeight="bold"  >
                                {displayPriceOverride ? (
                                    displayPriceOverride
                                ) : (
                                    <>
                                        {!!selectedPlan.planPricePrefix && selectedPlan.planPricePrefix} {selectedPlan.displayPrice}{' '}
                                        {selectedPlan.isPerPaxPricingDefined && <PerAdultLabel />}
                                    </>
                                )}
                            </Typography>

                            {selectedJourneyLeg == 0 && !disableCoupon && (
                                <Typography sx={{ fontSize: '12px', color: 'rgba(17, 163, 68, 1)', fontWeight: 'bold' }}>
                                    {exclusiveBenefits}
                                </Typography>
                            )}
                        </Box>


                    </>
                )}
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
                {/* Advisory sits immediately left of the CTA — it qualifies what the user is about to book. */}
                {!!note && (
                    <Alert severity="info" variant='standard' sx={{ py: 0, bgcolor: "#F9FAFA" }}>
                        {note}
                    </Alert>
                )}

                <Button
                    variant="customVariantPrimary"
                    disabled={!hasPrice}
                    onClick={handleFareFamilyBook}
                    sx={theme => ({
                        // backgroundColor: hasPrice ? theme.palette.primary.main : theme.palette.grey[400],
                        borderRadius: '0.5rem',
                        px: 3,
                        py: 1.2,
                        boxShadow: 'none',
                        flexShrink: 0,
                        // '&:hover': {
                        //     backgroundColor: hasPrice ? theme.palette.secondary.main : theme.palette.grey[400],
                        //     color: hasPrice ? theme.palette.primary.main : 'inherit',
                        //     boxShadow: 'none'
                        // }
                    })}
                >
                    {actionLabel ?? t('Continue')}
                </Button>
            </Box>
        </Box>
    )
}

export default FareModalFooter
